
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.855 22.588c-.23 0-.46-.08-.64-.24-.42-.36-.47-.99-.12-1.41.77-.92.92-2.01.57-2.45-.72-.91-1.79-3.71-.16-5.22a.997.997 0 111.36 1.46c-.53.49-.01 2.03.37 2.51 1.01 1.28.75 3.37-.61 4.98a.97.97 0 01-.77.37zm14.72 10.91c0 4.164-2.582 7.741-6.235 9.204a.996.996 0 01.264.626h4.261c4.93 0 8.4-2.53 8.43-2.56a.996.996 0 011.4.21c.33.44.24 1.07-.21 1.4-.16.12-4.04 2.95-9.62 2.95H37.59a.998.998 0 01-.984 1.18h-12.33a1.003 1.003 0 01-.983-1.18h-4.267c-5.58 0-9.46-2.83-9.62-2.95-.44-.33-.54-.96-.21-1.4.33-.44.95-.54 1.4-.21.04.03 3.54 2.56 8.43 2.56h4.252a.997.997 0 01.267-.63 9.967 9.967 0 01-5.857-6.51h-3.012c-2.29 0-4.15-1.86-4.15-4.15v-5.01c0-.55.45-1 1-1h5.79v-.55c0-.55.45-1 1-1h24.26c.55 0 1 .45 1 1v8.02zm-26.26-5.45h-4.78v4c0 1.18.96 2.15 2.15 2.15h2.64v-.252c-.006-.148-.01-.298-.01-.448v-5.45zm24.26 5.45v-2.33h-4.04c-.55 0-1-.45-1-1s.45-1 1-1h4.04v-2.69h-22.26v2.69h12.01c.55 0 1 .45 1 1s-.45 1-1 1h-12.01v2.33c0 4.36 3.55 7.91 7.91 7.91h6.44c4.36 0 7.91-3.55 7.91-7.91zm-8.86-10.75c.18.13.38.19.59.19.31 0 .61-.14.79-.4.78-1.07.91-2.43.31-3.3-.14-.22-.28-.81-.21-1 .36-.41.34-1.03-.06-1.4-.4-.37-1.03-.35-1.41.05-1.03 1.1-.33 2.93.04 3.47.06.1.04.56-.27.99-.32.45-.23 1.07.22 1.4z"}})])
          )
        }
      }
    